export default "__VITE_ASSET__CNH9tcIR__"